var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3335V13.8335H13.8333V13.3335H13.3333ZM10.3535 9.64661C10.1582 9.45135 9.84163 9.45135 9.64637 9.64661C9.4511 9.84187 9.4511 10.1585 9.64637 10.3537L10.3535 9.64661ZM12.8333 9.3335V13.3335H13.8333V9.3335H12.8333ZM13.3333 12.8335H9.33325V13.8335H13.3333V12.8335ZM13.6868 12.9799L10.3535 9.64661L9.64637 10.3537L12.9797 13.687L13.6868 12.9799Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 13.3335H2.16675V13.8335H2.66675V13.3335ZM6.35363 10.3537C6.5489 10.1585 6.5489 9.84187 6.35363 9.64661C6.15837 9.45135 5.84179 9.45135 5.64653 9.64661L6.35363 10.3537ZM2.16675 9.3335V13.3335H3.16675V9.3335H2.16675ZM2.66675 13.8335H6.66675V12.8335H2.66675V13.8335ZM3.0203 13.687L6.35363 10.3537L5.64653 9.64661L2.3132 12.9799L3.0203 13.687Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.6665H13.8333V2.1665H13.3333V2.6665ZM9.64637 5.64628C9.4511 5.84155 9.4511 6.15813 9.64636 6.35339C9.84163 6.54865 10.1582 6.54865 10.3535 6.35339L9.64637 5.64628ZM13.8333 6.6665V2.6665H12.8333V6.6665H13.8333ZM13.3333 2.1665H9.33325V3.1665H13.3333V2.1665ZM12.9797 2.31295L9.64637 5.64628L10.3535 6.35339L13.6868 3.02006L12.9797 2.31295Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 2.6665V2.1665H2.16675V2.6665H2.66675ZM5.64653 6.35339C5.84179 6.54865 6.15837 6.54865 6.35363 6.35339C6.5489 6.15813 6.5489 5.84155 6.35363 5.64628L5.64653 6.35339ZM3.16675 6.6665V2.6665H2.16675V6.6665H3.16675ZM2.66675 3.1665H6.66675V2.1665H2.66675V3.1665ZM2.3132 3.02006L5.64653 6.35339L6.35363 5.64628L3.0203 2.31295L2.3132 3.02006Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenBold);
export default __webpack_public_path__ + "static/media/fullscreen_bold.9e03134c5d67579583bb1a0a5d0fd1cc.svg";
export { ForwardRef as ReactComponent };